import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminTeamManagementstyle from "../ClubOwnerStyles/ClubOwnerTeamManagementstyle.module.css";
import Frame from "../../icons/Frame.svg";
import Trashcan from "../../icons/Trash can.svg"; // Update the import if the file name has changed
import Link from "../../icons/Link.svg"; // Update the import if the file name has changed
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const ClubOwnerTeamManagement = () => {
  const [MyTeams, setMyTeams] = useState([]);
  const [teams, setTeams] = useState([]);
  const [newPromoterUsername, setNewPromoterUsername] = useState("");
  const [newPromoterDisplayName, setNewPromoterDisplayName] = useState("");
  const [activeDays, setActiveDays] = useState([]);
  const [activeDaysPromoteurStats, setActiveDaysPromoteurStats] = useState([]);
  const [startDate, setstartDate] = useState(dayjs());
  const [endDate, setendDate] = useState(dayjs());
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackMessageType, setFeedbackMessageType] = useState("");
  const adminId = localStorage.getItem("adminId"); // or use your context/store if you have one

  // Fetch team promoters from the backend on component mount
  const handleStartDateChange = (newValue) => {
    setstartDate(newValue);
    if (newValue.isAfter(endDate)) {
      setendDate(newValue); // Set end date to new start date if it's later than the current end date
    }
  };

  const handleEndDateChange = (newValue) => {
    setendDate(newValue);
    if (newValue.isBefore(startDate)) {
      setstartDate(newValue); // Set start date to new end date if it's earlier than the current start date
    }
  };

  useEffect(() => {
    const fetchPromoters = async () => {
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/admin/team/${adminId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        console.log(response.data);
        setMyTeams(response.data.promotersData);
      } catch (error) {
        console.error("Error fetching promoters:", error);
      }
    };
    fetchPromoters();
  }, [adminId]);

  const fetchInvitations = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/admin/clubOwnerInvitations/${adminId}`,
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      setMyTeams(response.data); // Assuming the response data is the array of invitations
    } catch (error) {
      console.error("Error fetching invitations:", error);
    }
  };
  useEffect(() => {
    fetchInvitations();
  }, [adminId]); // Make sure clubOwnerId is available and correct

  const handleInvitationResponse = async (invitationId, accept) => {
    try {
      let token = localStorage.getItem("token");
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/replyInvitation`,
        {
          ClubOwnerId: adminId, // Ensure this is the correct ID
          adminId: invitationId, // Assuming this is the admin ID from the invitation
          accept
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      // Optionally, refresh the invitations list or update the UI accordingly
      fetchInvitations(); // Call the fetch function again to refresh the list
    } catch (error) {
      console.error("Error responding to invitation:", error);
    }
  };
  // Function to handle adding a new promoter
  const handleAddPromoter = async (e) => {
    e.preventDefault();
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/add_promoter_team/${adminId}`,
        {
          username: newPromoterUsername,
          display_name: newPromoterDisplayName,
          daysOfWeek: activeDays
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      setTeams(response.data.promotersData);
      setNewPromoterUsername("");
      setNewPromoterDisplayName("");
      setActiveDays([]);
      // Set success message
      setFeedbackMessage("Promoter added successfully to the team.");
      setFeedbackMessageType("success");
    } catch (error) {
      console.error("Error adding new promoter:", error);
      // Set error message from the response or a generic error message
      const message =
        error.response?.data?.message ||
        "Failed to add new promoter. Please try again.";
      setFeedbackMessage(message);
      setFeedbackMessageType("error");
    }
  };

  // Function to handle day toggling for new promoters
  const toggleDay = (day) => {
    setActiveDays((current) =>
      current.includes(day)
        ? current.filter((d) => d !== day)
        : [...current, day]
    );
  };
  const toggleDayPromoteurStats = (day) => {
    setActiveDaysPromoteurStats((current) =>
      current.includes(day)
        ? current.filter((d) => d !== day)
        : [...current, day]
    );
  };

  const GetPromotersTableData = async () => {
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/promoters-stats/`,
        {
          adminId: adminId, // Replace with actual adminId or retrieve it from context/state
          period: {
            start: startDate.format("YYYY-MM-DD"),
            end: endDate.format("YYYY-MM-DD")
          },
          weekDays: activeDaysPromoteurStats
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.data && Array.isArray(response.data)) {
        // Sort the data
        const sortedData = response.data.sort((a, b) => {
          // Sort by revenue (descending)
          if (a.revenue !== b.revenue) {
            return b.revenue - a.revenue;
          }
          // If revenue is equal, sort by totalReferrals (descending)
          if (a.totalReferrals !== b.totalReferrals) {
            return b.totalReferrals - a.totalReferrals;
          }
          // If totalReferrals is also equal, sort by scannedReferrals (descending)
          return b.scannedReferrals - a.scannedReferrals;
        });

        // Update state with sorted data
        setTeams(sortedData);
      }
    } catch (error) {
      console.error("Failed to fetch promoters data:", error);
      // Handle error appropriately
    }
  };

  const PromotersTable = ({ PromotersTableData }) => {
    return (
      <table>
        <thead>
          <tr>
            <th>Promoters</th>
            <th>Total Referrals</th>
            <th>Scanned Referrals</th>
            <th>Revenue</th>
          </tr>
        </thead>
        <tbody>
          {PromotersTableData.map((promoter) => (
            <tr key={promoter.id}>
              <td>
                <div className={AdminTeamManagementstyle.promoterDetail}>
                  {/*<img
                    src={promoter.image || "defaultProfileImage.png"}
                    alt="Promoter"
                    className={AdminTeamManagementstyle.promoterImage}
                  />*/}
                  <span>{promoter.promoterName}</span>
                </div>
              </td>
              <td>{promoter.totalReferrals}</td>
              <td>{promoter.scannedReferrals}</td>
              <td>{promoter.revenue}</td>
              <td>
                <div className={AdminTeamManagementstyle.actionButtons}>
                  <button onClick={() => handleDeletePromoter(promoter.id)}>
                    <img src={Trashcan} alt="Delete" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  // Function to delete a promoter
  const handleDeletePromoter = async (promoterId) => {
    try {
      let token = localStorage.getItem("token");
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/remove_promoter_team/${adminId}`,
        {
          data: { promoterId: promoterId },
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      setTeams(teams.filter((promoter) => promoter.id !== promoterId));
    } catch (error) {
      console.error("Error deleting promoter:", error);
    }
  };

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ];

  return (
    <div className={AdminTeamManagementstyle.adminTeamManagement}>
      <div className={AdminTeamManagementstyle.header1}>
        <div className={AdminTeamManagementstyle.headerTitle}>
          Launch a new Event!
        </div>
        <button className={AdminTeamManagementstyle.headerButton}>
          <img src={Frame} alt="Launch" />
        </button>
      </div>
      <div className={AdminTeamManagementstyle.gridContainer}>
        <div className={AdminTeamManagementstyle.sectionStyle}>
          <h2>Invitations</h2>
          <table>
            <thead>
              <tr>
                <th>Admin</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {MyTeams.map((invitation) => (
                <tr key={invitation._id}>
                  {" "}
                  {/* Make sure you use the correct identifier */}
                  <td>{invitation.name}</td>{" "}
                  {/* Display name or any identifier of the admin */}
                  <td>
                    <button
                      className={AdminTeamManagementstyle.addAdminButton}
                      onClick={() =>
                        handleInvitationResponse(invitation._id, true)
                      }
                    >
                      Accept
                    </button>
                    <button
                      className={AdminTeamManagementstyle.declineAdminButton}
                      onClick={() =>
                        handleInvitationResponse(invitation._id, false)
                      }
                    >
                      Decline
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={AdminTeamManagementstyle.cardStyle}>
          <h2>Add New Promoter to Team</h2>
          <div className={AdminTeamManagementstyle.inputField}>
            <label htmlFor="pattUsername">Enter Promoter PATT Username</label>
            <input
              type="text"
              id="pattUsername"
              placeholder="@PATTusername"
              value={newPromoterUsername}
              onChange={(e) => setNewPromoterUsername(e.target.value)}
            />
          </div>
          <div className={AdminTeamManagementstyle.inputField}>
            <label htmlFor="displayName">Enter Promoter Display Name</label>
            <input
              type="text"
              id="displayName"
              placeholder="First Name"
              value={newPromoterDisplayName}
              onChange={(e) => setNewPromoterDisplayName(e.target.value)}
            />
          </div>
          <div className={AdminTeamManagementstyle.selectDays}>
            <label>Select Working Days</label>
            <div className={AdminTeamManagementstyle.daysOfWeek}>
              {daysOfWeek.map((day) => (
                <button
                  key={day}
                  onClick={() => toggleDay(day)}
                  className={`${AdminTeamManagementstyle.dayButton} ${activeDays.includes(day) ? AdminTeamManagementstyle.activeDay : ""}`}
                >
                  {day}
                </button>
              ))}
            </div>
            <button
              className={AdminTeamManagementstyle.addPromoterButton}
              onClick={handleAddPromoter}
            >
              Add Promoter to the Team
            </button>
            {feedbackMessage && (
              <div
                style={{
                  color: feedbackMessageType === "error" ? "red" : "green",
                  marginTop: "10px"
                }}
              >
                {feedbackMessageType === "error"
                  ? "Error: " + feedbackMessage
                  : feedbackMessage}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={AdminTeamManagementstyle.sectionStyle2}>
        <h1>Team Ranking</h1>
        <label>Select Period</label>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker", "DatePicker"]}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={handleStartDateChange}
            />
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={handleEndDateChange}
            />
          </DemoContainer>
        </LocalizationProvider>
        <br />
        <label>Select Working Days</label>
        <div className={AdminTeamManagementstyle.daysOfWeek}>
          {daysOfWeek.map((day) => (
            <button
              key={day}
              onClick={() => toggleDayPromoteurStats(day)}
              className={`${AdminTeamManagementstyle.dayButton} ${activeDaysPromoteurStats.includes(day) ? AdminTeamManagementstyle.activeDay : ""}`}
            >
              {day}
            </button>
          ))}
        </div>

        <button
          className={AdminTeamManagementstyle.addPromoterButton}
          onClick={GetPromotersTableData}
        >
          Fetch PR Performance
        </button>
        <br />
        <PromotersTable PromotersTableData={teams} />
      </div>
    </div>
  );
};

export default ClubOwnerTeamManagement;
